import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DaoService } from '../../core/dao/dao.service';
import { IAudioPlugin } from '../../core/models/plugin.model';
import { TaskModel } from '../task/task.model';

@Component({
  selector: 'app-home',
  templateUrl: 'home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public plugins: IAudioPlugin[] = [];

  constructor(
    private dao: DaoService,
    public taskModel: TaskModel,
    private toastr: ToastrService) {

  }

  ngOnInit() {

  }

}
